import React, { Component } from 'react';
import Select from 'react-select';

import ProductionTransactionItem from '../components/production_transaction/item'
import ProcessingMessage from '../components/production_transaction/processing_messages'

export default class ProductionTransaction extends React.Component {
  constructor(props) {
    super();
    this.state = {
      stock_location_id:  undefined,
      manufacturing_id: props.manufacturing_id,
      manufacturing_name: props.manufacturing_name,
      input_items: props.input_items,
      output_items: props.output_items,
      stock_details: undefined,
      date: props.date,
    };
  }
  populateStockDetails = stock_location_id => {

    this.setState({ isLoading: true });
    const { options } = this.state;
    const $this = this
    $.ajax({
      type: "get",
      dataType: 'json',
      url: Biscraft.routes.manufacturing_stock_count_path,
      data: {
        "stock_location_id": stock_location_id, "id": this.state.manufacturing_id, token: Spree.api_key
      },
      success: function (stock_details) {
        console.log(`stockDetails ${stock_details} arrived.`)
        console.log( stock_details)

        $this.setState({
          stock_location_id: stock_location_id,
          stock_details: stock_details,
        });
       
      }
    });

  }



  stockLocationSelected = (e) => {
    const stock_location_id = e.value
    this.populateStockDetails(stock_location_id)

  }

  getStockCountHandler = (variant_id, fields_for) => {
    const {stock_details} =  this.state
    if (!stock_details) return "BLANK"

    // const fields_for = this.props.fields_for
    let matching
    if (fields_for == 'output_items') {
      matching = stock_details.output.find(item => { return item.id == variant_id })
    }
    else if (fields_for == 'input_items') {
      matching = stock_details.input.find(item => { return item.id == variant_id })
    }
    if (matching) {
      return matching.count_on_hand
    }
    else {
      return "NA"
    }

  };


  processProductionTranaction = (transactionType) => {
    const inputItems = this.state.input_items
    const outputItems = this.state.output_items
    $.ajax({
      type: "post",
      dataType: 'json',
      url: Biscraft.routes.production_transactions_path,
      data: {
        input_items: this.state.input_items, output_items: this.state.output_items,
        date: this.state.date,
        stock_location_id: this.state.stock_location_id, manufacturing_id: this.state.manufacturing_id, 
        token: Spree.api_key
      },
      success: function (stock_details) {
        console.log(`stockDetails ${stock_details} arrived.`)
        console.log(stock_details)

        $this.setState({
          stock_location_id: stock_location_id,
          stock_details: stock_details,
        });

      }
    });

  }

  disableProcessingSubmissionHandler = () => {
    const invalidItems = this.state.input_items.find( item => !item.isValid)
    return invalidItems ? true : false
  }

  updateQuantityHandler = (fields_for, updateItem, processingQuantity) => {
    const inputItems = this.state.input_items
    const outputItems = this.state.output_items

    if (fields_for == 'input_items'){
      var updatedInputItems = inputItems.filter( item => {
        if(item.id == updateItem.id)
        {
          item.processingQuantity = processingQuantity
        }
        return item;
      })
      this.setState({ input_items: updatedInputItems })

      if (updateItem.isValid && !isNaN(processingQuantity) )
      {
        const proportion = parseFloat(processingQuantity) / parseFloat(updateItem.quantity)
        const updatedOutputItems = outputItems.filter( item => {
          item.processingQuantity = parseFloat(item.quantity) * proportion 
          return item;
        })
                
        this.setState({ output_items: updatedOutputItems})
      }
      else if(!updateItem.isValid){
        const updatedOutputItems = outputItems.filter(item => {
          item.processingQuantity = ''
          return item;
        })
        this.setState({ output_items: updatedOutputItems })

      }

    }
    
  }
  render() {
    const stockLocations = this.props.stock_locations.map(sl => {
      return {value: sl.id, label: sl.name}
    })

    return (

     <div className="card">
 <div className="card-header">
   <div className="card-title">
      Add New Production Details
     <h3> {this.state.manufacturing_name}</h3>
   </div>
 </div>
 <div className='card-block'>
    <div className="row">
      <div className="col-md-6">

              <label>Stock Location</label>
              <Select
                options={stockLocations}
                placeholder="Select Stock Location"
                // value={this.state.stock_location_id}
                onChange={this.stockLocationSelected}
              >
              </Select>


            </div>
      <div className="col-md-6">
              <br />

      
              <div class='form-group form-group-default input-group required'>
                <div class='form-input-group'>
                  <label>Date</label>
                  <input type="text" 
                    value = {this.state.date}
                    onChange={ (e) => this.setState({date: e.target.value})}
                    className= 'form-control datepicker' placeholder="Pick a date"
                    required = "required" />
                </div>
                <div class='input-group-addon'>
                  <i class='fa fa-calendar'></i>
                </div>
              </div>
      </div>
    </div>
 
     <br />
  <div className={ this.state.stock_location_id ? '' : 'hide' }>

    <div class="row">
      <div class="col-md-6">
        <div class="card">
          <div class="card-header">
            <div class="card-title">
                      <span>Input Items</span>
            </div>
          </div>
          <div class='card-block'>

            {this.props.input_items.map(item => {
              return <ProductionTransactionItem
                item={item}
                getStockCountHandler={this.getStockCountHandler}
                updateQuantityHandler={this.updateQuantityHandler}
                stock_details={this.state.stock_details}
                fields_for="input_items"
                key={item.id}
              />

            })}

            <ProcessingMessage
              transactionType='input_based'
              processTransactionHandler={this.processProductionTranaction}
              inputItems={this.props.input_items}
              getStockCountHandler={this.getStockCountHandler}
              disableProcessingSubmissionHandler={this.disableProcessingSubmissionHandler}

            />


          </div>
        </div>
      </div>

      <div class="col-md-6">
        <div class="card">
          <div class="card-header">
            <div class="card-title">
                      <span>Output Items</span>
            </div>
          </div>
          <div class='card-block'>

                      {this.props.output_items.map(item => {
                        return <ProductionTransactionItem
                          item={item}
                          getStockCountHandler={this.getStockCountHandler}
                          updateQuantityHandler={this.updateQuantityHandler}
                          stock_details={this.state.stock_details}
                          fields_for="output_items"
                          key={item.id}

                        />

                      })}

          </div>
        </div>
      </div>
    </div>

   
  </div>
 </div>
</div>

    );
  }
}